import React from 'react'
import { GetEstateVisitsQuery } from '@gql'
import { format } from 'date-fns'
import { ScrollArea } from '@/components/ui/scroll-area'
import { EstateVisitRow } from './EstateVisitRow'

type EstateVisitsListProps = {
  visits: GetEstateVisitsQuery['visit']
  visitSlotDuration: number
}
export const EstateVisitsList = ({
  visits,
  visitSlotDuration,
}: EstateVisitsListProps) => {
  const sortedVisits = [...visits].sort(
    (a, b) => new Date(a.startTime).getTime() - new Date(b.startTime).getTime()
  )

  return (
    <ScrollArea className="tw-h-[400px] tw-p-4 tw-pb-[2px]">
      <div className="tw-grid tw-grid-cols-1 tw-gap-4">
        {sortedVisits.map((visit, index) => (
          <div
            key={visit.id}
            className="tw-flex tw-gap-2 tw-text-zinc-500 tw-text-sm tw-items-center tw-justify-between"
          >
            <span>
              {(index === 0 ||
                visit.startTime !== sortedVisits[index - 1].startTime ||
                visit.endTime !== sortedVisits[index - 1].endTime) && (
                <>
                  {format(new Date(visit.startTime), 'HH:mm')} -{' '}
                  {visit.endTime && format(new Date(visit.endTime), 'HH:mm')}
                </>
              )}
            </span>
            <EstateVisitRow
              visit={visit}
              visitSlotDuration={visitSlotDuration}
            />
          </div>
        ))}
      </div>
    </ScrollArea>
  )
}
